function createParallax(images, speed, span) {
    let lastScrollY = window.scrollY;

    function updateParallax() {
        const currentScrollY = window.scrollY;

        if (currentScrollY !== lastScrollY) {
            images.forEach(image => {
                let offset = currentScrollY * speed;

                // Clamp the offset to stay within the defined span
                offset = Math.max(-span, Math.min(offset, span));

                image.style.transform = `translateY(${offset}px)`;
            });
            lastScrollY = currentScrollY;
        }

        // Request the next frame
        requestAnimationFrame(updateParallax);
    }

    // Start the animation loop
    requestAnimationFrame(updateParallax);
}

jQuery(window).load(function () {
    (function (e) {

        //add arrow to nav items w submenu
        if (e('#main-nav li').hasClass('menu-item-has-children')) {
            e('#main-nav li.menu-item-has-children').append('<span class="menu-arrow"></span>');
        }
        e('.dropdown-toggle.nav-link').on('click', function (event) {
            window.location = e(this).attr('href');
        });
        //toggle submenus
        e('.menu-arrow').on('click', function () {
            if (!e(this).parent().hasClass('expanded')) {
                e('.mobile-nav li.menu-item-has-children').removeClass('expanded');
                e('span.menu-arrow').removeClass('rotate');
                e(this).parent().addClass('expanded');
                e(this).addClass('rotate');
            } else {
                e(this).parent().toggleClass('expanded');
                e(this).toggleClass('rotate');
            }
        });
        // menu dropdowns
        e('.dropdown-toggle.nav-link').on('click', function (event) {
            window.location = e(this).attr('href');
        });
        e('.dropdown-toggle.nav-link ~ span').on('click', function (event) {
            console.log('arrow')
            // if (e(window).width() <= 768) {}
            if (e(this).hasClass('arrow-opened')) {
                e(this).removeClass('arrow-opened');
                e('.dropdown-menu.show').removeClass('show');
            } else {
                e('.arrow-opened').removeClass('arrow-opened');
                e(this).addClass('arrow-opened');

                e('.dropdown-menu.show').removeClass('show');
                e(this).parent().find('.dropdown-menu').addClass('show');
            }

            event.preventDefault();
            event.stopPropagation();

        });
        e(window).resize(function () {
            if (e(window).width() >= 768) {
                e('.dropdown-menu.show').removeClass('show');
                e('.arrow-opened').removeClass('arrow-opened');
            }

            if (e(window).width() < 768) {
                console.log('hello--');
                e('#extra-menu__btns').addClass('showw');
            }
        });




        console.log('custom-javascript.js loaded', e('.people-btn'));
        e('.people-row .btn-close-circle').on('click', function (event) {
            e('.people-in').removeClass('people-in');
            lumPauseAllVideos();
        });
        e('.people-btn').on('click', function (event) {
            e('.people-in').removeClass('people-in');
            e('.people-btn').attr('aria-expanded', 'false');
            var $currentRow = e(this).parents('.category-people');//('.people-row');
            $currentRow.addClass('people-in');
            $currentRow.find('.people-btn').attr('aria-expanded', 'true');
        });


        const images = document.querySelectorAll('.parallax-image'); // Update selector
        createParallax(images, -0.3, 200);

         
        const awbImgs = document.querySelectorAll('.nk-awb-wrap .jarallax-container img');
        if (awbImgs) {
            awbImgs.forEach(function (awbImg) {
                awbImg.setAttribute("alt", "");
            });
        }

        // cookies-settings javascript:Optanon.ToggleInfoDisplay()
        const cookiesSettings = document.querySelectorAll('.cookies-settings a');
        if (cookiesSettings) {
            cookiesSettings.forEach(function (cookiesSettingsBtn) {
                cookiesSettingsBtn.setAttribute('role', 'button');
                cookiesSettingsBtn.setAttribute('href', 'javascript:void(0);');
                cookiesSettingsBtn.addEventListener("click", function (e) {
                    e.preventDefault();
                    Optanon.ToggleInfoDisplay();
                });
            });
        }



        // video managment // people-btn
        var puOpen = document.querySelectorAll('[data-bs-toggle="modal"], .people-btn');
        var puClose = document.querySelectorAll('.modal .btn-close');
        console.log('puClose', puClose)
        if (puOpen) {
            puOpen.forEach(function (puOpenBtn) {
                puOpenBtn.addEventListener("click", function () {
                    lumPauseAllVideos();
                    console.log('popup open clicked');
                });
            });
        };
        if (puClose) {
            puClose.forEach(function (puCloseBtn) {
                puCloseBtn.addEventListener("click", function () {
                    lumPauseAllVideos()
                    console.log('popup close clicked');
                });
            })
        };


    })(jQuery);

});

function lumPauseAllVideos() {
    for (var key in lumPlayersObj) {
        lumPlayersObj[key].pause();
    }
}
var lumPlayersObj = {};
var lumPlayersArr = [];
wp.hooks && wp.hooks.addAction("presto.playerReady", "my-plugin-namespace", function (player) {
    var idValue = player.id;
    console.log('player READY', player, idValue);
    if (!lumPlayersObj[idValue]) {
        lumPlayersObj[idValue] = player;
        lumPlayersArr.push(player);
    }
});

function collapseExtraMenu() {
    if (jQuery(window).width() < 768) {
        jQuery('#extra-menu__btns').removeClass('show');
        jQuery('#extra-menu .trigger').addClass('collapsed');
    }
}

jQuery(document).ready(function() {
    (function (e) {
        collapseExtraMenu();

        e(window).resize(function () {
            collapseExtraMenu();
        });
    })(jQuery);
});
